/* eslint-disable react/no-multi-comp, react/prop-types */
import 'loaders.css/loaders.css';

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

export default class LineLoader extends React.Component {
  static propTypes = {
    loader: PropTypes.string,
    color: PropTypes.string,
    divs: PropTypes.number
  };

  static defaultProps = {
    color: '#2c3e50',
    divs: 5
  };

  render() {
    const classes = classNames(this.props.loader, 'loader-inner');
    const styles = { backgroundColor: this.props.color };
    const divs = [];

    _.times(this.props.divs, (n) => divs.push(<div key={n} style={styles}></div>));

    return (
      <div className={classes}>{divs}</div>
    );
  }
}

export function RoundLoader({ className, color, style, ...props }) {
  const classes = classNames(className, 'ball-clip-rotate', 'loader-inner');
  const styles = color ? { borderColor: `${color} ${color} ${color} transparent`, ...style } : undefined;
  
  return (
    <div className={classes} {...props}><div style={styles}></div></div>
  );
}
